module.exports = __webpack_public_path__ + "media/country_flags/gn-4d378d60.png";